import { useState } from 'react'
import { useFilterLabels } from './useFilterLabels'
import type { FilterOperator } from '@/lib/types/filter'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { cn } from '@/lib/utils'

interface FilterOperatorSwitchProps {
  operator: FilterOperator
  availableOperators: Array<FilterOperator>
  onChange: (operator: FilterOperator) => void
}

export function FilterOperatorSwitch({
  operator,
  availableOperators,
  onChange,
}: FilterOperatorSwitchProps) {
  const [open, setOpen] = useState(false)
  const { operatorLabel } = useFilterLabels()

  if (availableOperators.length <= 1) {
    return (
      <span className="text-muted-foreground">
        {operatorLabel(operator)}
      </span>
    )
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="text-muted-foreground transition-colors hover:text-foreground">
          {operatorLabel(operator)}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-36 p-1" align="start">
        {availableOperators.map((op) => (
          <button
            key={op}
            className={cn(
              'flex w-full items-center rounded-sm px-2 py-1.5 text-sm hover:bg-accent transition-colors',
              op === operator && 'bg-accent/50 font-medium',
            )}
            onClick={() => {
              onChange(op)
              setOpen(false)
            }}
          >
            {operatorLabel(op, 'menu')}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  )
}
